import { useQuery } from "@tanstack/react-query"
import { Col, Row, Select } from "antd"
import { DefaultOptionType, SelectProps } from "antd/es/select"
import { filterOption } from "components/inputs/helpers"
import { Text } from "components/UI"
import api from "helpers/api"
import { Uuid } from "types"
import { ListingResponse } from "types/api"
import { SelectEntity } from "../types"
import { getOnSelectData } from "./onSelect"

interface ModelSelectProps {
    setActiveModel: (v: SelectEntity | null) => void
    activeModel: SelectEntity | null
    required?: boolean
    layout?: "vertical" | "horizontal"
    skipValues?: Uuid[]
    activeGroupId?: Uuid
    activeSeriesId?: Uuid
    size?: SelectProps["size"]
}

export function ModelSelect({
    setActiveModel,
    required,
    layout = "horizontal",
    activeModel,
    activeGroupId,
    activeSeriesId,
    size,
}: ModelSelectProps) {
    const { data, isFetching } = useQuery<DefaultOptionType[]>({
        queryKey: ["get-models", activeGroupId, activeSeriesId],
        enabled: !!activeGroupId && !!activeSeriesId,
        queryFn: () =>
            api
                .getTyped<ListingResponse>("listing/model", {
                    method: "asc",
                    sort: "name",
                    count_on_page: Number.MAX_SAFE_INTEGER,
                    itemsGroups: activeGroupId,
                    series: activeSeriesId,
                })
                .then((response) => {
                    return response.entities.map(
                        (el) =>
                            ({
                                label: el.fields.find(
                                    (field) => field.name === "name"
                                )!.value,
                                value: el.fields.find(
                                    (field) => field.name === "id"
                                )!.value,
                            } as DefaultOptionType)
                    )
                }),
        initialData: [],
    })

    const labelSpan = layout === "horizontal" ? 5 : 24
    const inputSpan = layout === "horizontal" ? 19 : 24

    const onChange = (v: any) => {
        setActiveModel(v ? getOnSelectData(v) : null)
    }

    return (
        <Row gutter={[0, 10]}>
            <Col xs={24} md={labelSpan}>
                <Text.FormLabel required={required}>Модель</Text.FormLabel>
            </Col>
            <Col xs={24} md={inputSpan}>
                <Select
                    size={size}
                    loading={isFetching}
                    showSearch
                    filterOption={filterOption}
                    className="fw"
                    placeholder="Выберите модель"
                    options={data}
                    value={activeModel}
                    onChange={(_, option) => onChange(option)}
                    allowClear
                    disabled={!activeSeriesId}
                />
            </Col>
        </Row>
    )
}
